import useTranslation from "next-translate/useTranslation";
import Link from "next/link";
import { useRouter } from "next/router";
import { useUser } from "../../../hooks/useUser";
import { Container } from "../../Container/Container";

export const ProfileSite = () => {
    const router = useRouter();
    const { isLoading, data } = useUser(router.query.username as string);
    const { t } = useTranslation('users');
    
    return <Container className="my-1 whitespace-pre-line flex flex-col items-center gap-y-2 py-4" topL={false} topR={false} bottomL={false} bottomR={false}>
        <h4 className="font-bold">{t('followOn')}</h4>
        <Link className="link link-primary text-center" target="_blank" rel="noreferrer" href={data?.site || '#'}>{data?.site}</Link>
    </Container>
}